module.exports = __webpack_public_path__ + "static/media/preview@768.de1b563d.png";